<template>
    <AppCollapse
        type="margin"
        class="vertical-steps-flow"
        :accordion="accordion"
    >
        <StepHost
            v-for="step in steps"
            :key="step.id"
            :data-workflow-step-id="step.id"
            :context="context"
            :step="step"
            :review-contributions="reviewContributions"
            v-on="$listeners"
        />
    </AppCollapse>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import StepHost from './StepHost.vue'

export default {
    name: 'VerticalCollapseRenderer',
    components: {
        AppCollapse,
        StepHost,
    },
    props: {
        accordion: {
            type: Boolean,
            required: true,
        },
        rendererSettings: {
            type: Object,
            default: () => ({}),
        },
        context: {
            type: Object,
            required: true,
        },
        steps: {
            type: Array,
            required: true,
        },
        reviewContributions: {
            type: Array,
            default: () => [],
        },
    },
}
</script>
